<script setup lang="ts">
import { ref } from 'vue';
import { FontAwesomeIcon } from '@shared/plugin/icons';
import VPopover from '../VPopover/VPopover.vue';
import { type VPopoverTheme } from '../VPopover/VPopover.styles';

const props = withDefaults(
  defineProps<{
    label?: string;
    active?: boolean;
    sticky?: boolean;
    theme?: VPopoverTheme;
  }>(),
  {
    active: true,
    sticky: false,
    theme: 'dark',
  },
);

const popoverRef = ref<InstanceType<typeof VPopover>>();
</script>

<template>
  <div>
    <div @mouseenter="popoverRef?.show" @mouseleave="() => !props.sticky && popoverRef?.hide()">
      <slot></slot>
    </div>
    <VPopover
      v-bind="$attrs"
      :theme="props.theme"
      ref="popoverRef"
      v-if="props.active"
      class="max-w-[300px]"
      role="tooltip"
    >
      <div class="flex gap-2 px-3 py-2 text-sm">
        <FontAwesomeIcon class="mt-0.5 text-base" icon="far fa-info-circle" />
        <div
          class="whitespace-pre-wrap"
          v-if="!$slots.content"
          v-sanitized-html="props.label"
        ></div>
        <div>
          <slot name="content"></slot>
        </div>
      </div>
    </VPopover>
  </div>
</template>
